import { useMemo } from "react";

import { DealerComparisonPricesPayload } from "../../queries/useGetDealerComparisonPricesByTireSize";

export const useBrands = (data?: DealerComparisonPricesPayload): string[] => {
  const sortedBrands = useMemo(() => {
    if (!data) {
      return [];
    }
    const brands = data.map((item) => item.brand);
    const uniqueBrands = [...new Set(brands)];
    return uniqueBrands.sort((a, b) => a.localeCompare(b));
  }, [data]);

  return sortedBrands;
};
